import { icon, Icon } from '../lib/fa-icons.js';
import { render } from "preact";
import Widget from "./base.js";
import $ from "jquery";

export class SignInForm extends Widget {
	componentWillMount() {
		this.submitForm = this.submitForm.bind(this);
		this.setError = this.setError.bind(this);
	}

	setError(message) {
		this.setState({
			error: message,
		});
	}

	pwToggle() {
		this.setState({
			revealed: !this.state.revealed,
		});
	}

	handleInput() {
		// doing it this way hacks around the issue of browser autofills
		// not triggering the onchange event
		let newState = {
			login: $("#user_login").val(),
			password: $("#user_pass").val(),
		};

		if (this.state.twoFactor)
			newState.second_factor_token = $("#second_factor_token").val();

		this.setState(newState);
	}

	submitForm(e) {
		e.preventDefault();
		this.handleInput(); // handles forms that are autofilled by the browser when the page is loaded
		var form = $(".js_loginform");

		$(".js_loginerror").text("");

		if (
			!this.state.login ||
			!this.state.password ||
			(this.state.twoFactor && !this.state.second_factor_token)
		) {
			this.setError("All fields are required");
			return;
		}

		// send ppl back to where they came from when they log in,
		// assuming the referrer is same origin
		const referrer =
			document.referrer.indexOf(
				window.location.protocol + "//" + window.location.host
			) === 0
				? document.referrer
				: document.location.origin;

		const self = this;

		$.ajax({
			type: "GET",
			url:
				"https://" + window.location.hostname + "/session/csrf?_=" + Date.now(),
			xhrFields: { withCredentials: true },
			beforeSend: function (xhr) {
				xhr.setRequestHeader("X-Requested-With", "XMLHTTPRequest");
			},
		}).then(function (r) {
			$.ajax({
				type: "POST",
				url: "https://" + window.location.hostname + "/session",
				data: form.serialize(),
				xhrFields: { withCredentials: true },
				beforeSend: function (xhr) {
					xhr.setRequestHeader("X-CSRF-Token", r.csrf);
					xhr.setRequestHeader("X-Requested-With", "XMLHTTPRequest");
				},
				success: function (r) {
					if (
						!self.state.twoFactor &&
						r.error &&
						(r.reason === "invalid_second_factor_method" ||
							r.reason === "invalid_second_factor")
					)
						self.setState({
							twoFactor: true,
							error: false,
							second_factor_token: null,
						});
					else if (r.error) self.setError(r.error);
					else window.location.href = referrer;
				},
				error: function (r) {
					if (r.responseJSON.errors) self.setError(r.responseJSON.errors[0]);
					else
						self.setError(
							"An error occured, please contact us at siteissues@talkingpointsmemo.com"
						);
				},
			});
		});
	}

	renderError() {
		if (!this.state.error) return;
		return (
			<div class="SignInForm__ErrorContainer js_loginerror">
				<div class="SignInForm__Error">{this.state.error}</div>
			</div>
		);
	}

	renderInputs() {
		if (!this.state.twoFactor)
			return (
				<div>
					<h1>SIGN IN</h1>
					<p>
						<label for="user_login">
							Username or Email Address
							<br />
							<input
								type="text"
								name="login"
								id="user_login"
								class="input"
								value={this.state.login}
								oninput={this.handleInput.bind(this)}
							/>
						</label>
					</p>

					<p>
						<label for="user_pass">
							Password
							<br />
							<input
								type={this.state.revealed ? "text" : "password"}
								name="password"
								id="user_pass"
								class="input"
								value={this.state.password}
								oninput={this.handleInput.bind(this)}
							/>
							<span
								class="SignInForm__RevealPassword"
								onclick={this.pwToggle.bind(this)}
							>
								{this.state.revealed ? (
									<span>
										<Icon name="eye-slash" style="regular" /> hide
									</span>
								) : (
									<span>
										<Icon name="eye" style="regular" /> show
									</span>
								)}
							</span>
						</label>
					</p>
				</div>
			);

		return (
			<div>
				<h3>Two Factor Authentication</h3>
				<p>
					<label for="user_pass">
						Two-factor authentication code
						<br />
						<input
							type="text"
							name="second_factor_token"
							id="second_factor_token"
							class="input"
							value={this.state.second_factor_token}
							oninput={this.handleInput.bind(this)}
						/>
					</label>
				</p>
				<input
					type="hidden"
					name="login"
					id="user_login"
					class="input"
					value={this.state.login}
				/>
				<input
					type="hidden"
					name="password"
					id="user_pass"
					class="input"
					value={this.state.password}
				/>
				<input
					type="hidden"
					name="second_factor_method"
					id="second_factor_method"
					value="1"
				/>
			</div>
		);
	}

	renderContent() {
		return (
			<div class="">
				<form
					name="loginform"
					class="SignInForm__Form --user-pass js_loginform"
				>
					{this.renderInputs()}
					{this.renderError()}
					<p>
						<button class="SignInForm__Submit" onclick={this.submitForm}>
							SIGN IN
						</button>
					</p>
				</form>
				<p>
					<a
						class="SignInForm__Link"
						href={`https://accounts.${document.location.hostname}/account/recover`}
					>
						I need help signing in
					</a>
				</p>
				<p>
					<a
						class="SignInForm__Link"
						href={`https://${document.location.hostname}`}
					>
						← Back to Talking Points Memo
					</a>
				</p>
			</div>
		);
	}
}
